import React, { useEffect } from 'react';
import { useNoIndex } from '../utils/jsonLd';

/**
 * Full-page notice for any visitor whose IP sits in `blocked_ips`.
 * Deliberately stripped back: black screen, green terminal type, one line.
 */
const BannedPage = () => {
  useNoIndex();

  useEffect(() => {
    const previous = document.title;
    document.title = 'BANNED';
    return () => { document.title = previous; };
  }, []);

  return (
    <div
      data-testid="banned-page"
      className="min-h-screen w-full bg-black flex items-center justify-center px-6"
      style={{ fontFamily: '"Courier New", Courier, monospace' }}
    >
      <h1
        data-testid="banned-headline"
        className="text-[#00ff41] text-2xl sm:text-4xl md:text-5xl font-bold tracking-[0.12em] uppercase text-center leading-snug"
        style={{ textShadow: '0 0 12px rgba(0,255,65,0.55)' }}
      >
        You&apos;re banned, fuck wit
      </h1>
    </div>
  );
};

export default BannedPage;
